/**
 * @file index.tsx
 *
 * @fileoverview Renders a button that opens the current CMP preferences window.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { allowedCmpProviders } from '~/jobiqo/lib/cmp';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { ButtonLink } from '~/vcl/atoms/01-forms/01-button/01-button-link';
import styles from './preferencesButton.module.scss';

interface CMPPreferencesButtonProps {}

const CMPPreferencesButtonText = () => {
  return (
    <FormattedMessage id="cmp_preferences_button" defaultMessage="Consents" />
  );
};

const CMPPreferencesButtonElement = () => {
  const { APP } = useFrontendConfig();
  const CMP_PROVIDER = APP.CMP_PROVIDER;
  switch (CMP_PROVIDER) {
    case allowedCmpProviders.OneTrust:
      return (
        // We need to use inline styling for OneTrust button as CMP is adding some styling, and then it looks like
        // a button, but we have this link in the footer menu so want to override styling.
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof window.OneTrust != 'undefined') {
              // @ts-ignore
              window.OneTrust.ToggleInfoDisplay();
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.Usercentrics:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof window.UC_UI != 'undefined') {
              // @ts-ignore
              window.__ucCmp.showFirstLayer();
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.ConsentManager:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof __cmp != 'undefined') {
              // @ts-ignore
              __cmp('showScreen');
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.TrustCommander:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof tC != 'undefined') {
              // @ts-ignore
              tC.privacyCenter.showPrivacyCenter();
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.Traffective:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof __tcfapi != 'undefined') {
              // @ts-ignore
              window.__tcfapi('showUi', 2, function () {});
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.Didomi:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof window.Didomi != 'undefined') {
              // @ts-ignore
              Didomi.preferences.show();
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.CivicCookieControl:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            // @ts-ignore
            if (typeof window.CookieControl != 'undefined') {
              // @ts-ignore
              window.CookieControl.open();
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    case allowedCmpProviders.CookieScript:
      return (
        <ButtonLink
          className={`${styles.defaultStyle}`}
          onClick={() => {
            if (typeof (window as any)?.CookieScript != 'undefined') {
              (window as any)?.CookieScript.instance.show();
            }
          }}
        >
          <CMPPreferencesButtonText />
        </ButtonLink>
      );
    default:
      return null;
  }
};

export const CMPPreferencesButton = ({}: CMPPreferencesButtonProps) => {
  const { APP } = useFrontendConfig();
  const CMP_ID = APP.CMP_ID;
  const CMP_PROVIDER = APP.CMP_PROVIDER;
  const CMP_PREF_BUTTON = APP.CMP_PREF_BUTTON;
  return CMP_ID && CMP_PREF_BUTTON ? (
    <li>
      <CMPPreferencesButtonElement key={CMP_PROVIDER} />
    </li>
  ) : null;
};
export default CMPPreferencesButton;
